// extracted by mini-css-extract-plugin
var _1 = "SearchPlatformMenuItem-module__addedIcon--ASCug";
var _2 = "SearchPlatformMenuItem-module__addedIconContainer--iCqEk";
var _3 = "SearchPlatformMenuItem-module__animatedBackground--glUzA";
var _4 = "SearchPlatformMenuItem-module__authorized--cru3u";
var _5 = "SearchPlatformMenuItem-module__clearIcon--QH96v";
var _6 = "SearchPlatformMenuItem-module__container--iqGJn";
var _7 = "SearchPlatformMenuItem-module__content--dgkNm";
var _8 = "SearchPlatformMenuItem-module__logo--PqCG8";
var _9 = "SearchPlatformMenuItem-module__name--ftJwR";
var _a = "SearchPlatformMenuItem-module__platformModes--JzeB3";
export { _1 as "addedIcon", _2 as "addedIconContainer", _3 as "animatedBackground", _4 as "authorized", _5 as "clearIcon", _6 as "container", _7 as "content", _8 as "logo", _9 as "name", _a as "platformModes" }
